import * as Yup from 'yup';

const AddAccountTransactionValidationSchema = Yup.object().shape({
  payment_type: Yup.string().required('Transaction type is required'),
  credit_amount: Yup.number()
    .required('Amount is required')
    .test('not-zero', 'Amount cannot be zero', (value) => value !== 0),
  payment_by: Yup.string().required('Applied By is required'),
  reference_number: Yup.string(),
  notes: Yup.string(),
});

export default AddAccountTransactionValidationSchema;
